<template>
  <div class="assistant-catalog">
    <Button v-if="useAppStateStore().features.manageAssistants" type="button" size="small" icon="pi pi-plus" label="Создать ассистента" @click="$emit('create')"/>
    <Message v-else>
      Чтобы создавать своих ассистентов - зарегистрируйтесь/войдите в аккаунт
    </Message>
    <div class="assistant-modal__body assistant-catalog__body">

      <div class="assistant-catalog__info">
        <div>
          Создавайте своих ассистентов или используйте из каталога. Нажмите "Добавить" для добавления ассистента в
          диалог.
        </div>
        <div v-if="blockAdding">
          <Message severity="info">
            В диалог добавлено максимальное количество ассистентов.
          </Message>
        </div>
      </div>
      <div class="assistant-catalog__items">
        <div v-for="assistant in listAssistants" :key="assistant.id" class="assistant-catalog__item">
          <div class="assistant-catalog__item-info">
            <Avatar size="small" class="assistant-catalog__item-icon" :image="assistant.icon" shape="circle"/>
            <div class="assistant-catalog__item-name" :title="assistant.name">
              {{ assistant.name }}
            </div>
          </div>
          <div class="assistant-catalog__item-actions">
            <Button v-if="assistant.selected" size="small" type="button" severity="secondary" icon="pi pi-minus"
                    class="assistant-catalog__detach-button"
                    label="Убрать" @click="$emit('detach', assistant.id)"/>
            <Button v-else :disabled="blockAdding" size="small" type="button" severity="secondary" icon="pi pi-plus"
                    v-tooltip.bottom="disabledTooltip"
                    :class="{'assistant-catalog__button--disabled': blockAdding}"
                    label="Добавить" @click="$emit('attach', assistant.id)"/>
            <Button
                type="button"
                size="small"
                severity="secondary"
                icon="pi pi-eye"
                @click="$emit('view', assistant)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed} from "vue";
import {useReferenceStore} from "@/modules/chat/stores/referenceStore";
import {useChatStore} from "@/modules/chat/stores/chatStore";
import Avatar from "primevue/avatar";
import Button from "primevue/button";
import Message from "primevue/message";
import {useAppStateStore} from "@/modules/chat/stores/appStore";

const emit = defineEmits(['create', 'view', 'attach', 'detach']);

const reference = useReferenceStore();
const chatState = useChatStore();

const {assistants_limit: assistantsLimit} = useReferenceStore();
const blockAdding = computed(() => chatState.assistants.length >= assistantsLimit);
const disabledTooltip = computed(() => blockAdding.value ? `В диалог добавлено максимальное количество ассистентов` : '');

const listAssistants = computed(() => {
  const dialogAssistants = chatState.assistants;
  return reference.assistants.map(assistant => {
    const selected = dialogAssistants.find(a => a.assistant_id === assistant.id);
    assistant.selected = !!selected;
    return assistant;
  });
});
</script>